import { G } from 'smg/querystring';

export const Input = document.querySelector('#account-search-input') as HTMLInputElement | null;
export const Form = document.querySelector('#account-search-form') as HTMLFormElement | null;

export function AppendAndSubmit(s: string) {
    if (!(Input && Form)) {
        return;
    }

    Input.value = `${Input.value} ${s}`.trim();
    Form.dispatchEvent(new Event('submit', { cancelable: true }));
}

if (Input && Form) {
    Form.addEventListener('submit', e => {
        e.preventDefault();
        G().Set('q', Input.value);
    });
    Input.value = G().Get('q') || '';
}